import angular from 'angular';
import calendarMini from './calendarMini';

export default angular
  .module('calendarMini', [])
  .component('calendarMini', calendarMini).name;
